import type * as React from "react";

import { cx } from "../../lib/cx";
import s from "./Text.module.css";

export type TextSize = "xs" | "sm" | "md" | "lg";
export type TextTone = "body" | "muted" | "subtle" | "strong" | "brand" | "accent" | "inverse" | "success" | "warning" | "danger";

export interface TextProps extends React.ComponentPropsWithoutRef<"p"> {
  /** `p` por default. `span` para texto en línea, `div` para un bloque sin semántica de párrafo. */
  as?: "p" | "span" | "div" | "small" | "strong" | "em" | "dd" | "dt" | "li" | "figcaption";
  size?: TextSize;
  tone?: TextTone;
  weight?: "regular" | "medium" | "semibold" | "bold";
  /** Cifras, códigos y fechas: JetBrains Mono con `tabular-nums`. */
  mono?: boolean;
  /** Corta el texto en una línea con puntos suspensivos. */
  truncate?: boolean;
}

/** Texto en Nunito Sans. Sin margen: el espacio lo pone el contenedor. */
export function Text({ as = "p", size = "md", tone = "body", weight, mono, truncate, className, ...rest }: TextProps) {
  const Tag = as as React.ElementType;
  return (
    <Tag
      className={cx(s.text, className)}
      data-size={size}
      data-tone={tone}
      data-weight={weight}
      data-mono={mono || undefined}
      data-truncate={truncate || undefined}
      {...rest}
    />
  );
}
